// Ticking an order's products as they're picked, and what Fulfil then does.
// The order view ticks a line as the route sheet does: where Bolt has picks
// (useRoutePicks), a tick is a pick, seen on every phone and in the
// warehouse app; elsewhere, and for Missing reports, the ticks are the pick
// list's kept on this device (routeSheet.js). The helpers below read either,
// as { picked, missing } sets of line ids.
import { togglePick } from "../../../../../Shipper/Customer/MainPages/Orders/Components/DeliveryRoutes/routeSheet";
import { lineFulfilment } from "./OrderItems";

// The lines a status pop-up fulfils: Bolt lines (synced marketplace lines
// aren't).
export const boltLines = (order) =>
  (order?.order_details || []).filter((item) => !item?.plugin_item_id);

// Nothing is left to pick once an order is fulfilled, cancelled or archived.
export const pickingOver = (statusName) =>
  /^(fulfilled|cancel|archiv)/i.test(String(statusName ?? "").trim());

/**
 * A Bolt line's pick: "picked" when ticked (here or on a pick list, on this
 * device), or already fulfilled in full and not reported missing since;
 * "missing" when reported missing; null otherwise.
 */
export const pickStateOf = (picks, item, statusName) => {
  const id = String(item?.id);
  if (picks.picked.has(id)) return "picked";
  if (picks.missing.has(id)) return "missing";
  return lineFulfilment(item, statusName)?.label === "Fulfilled"
    ? "picked"
    : null;
};

// Ticking or unticking a line. A line shown picked because it was fulfilled
// before is unticked by reporting it missing.
export const togglePicked = (picks, item, statusName) => {
  const id = String(item?.id);
  if (pickStateOf(picks, item, statusName) === "picked") {
    return picks.picked.has(id)
      ? togglePick(picks, [id], "picked")
      : togglePick(picks, [id], "missing");
  }
  return togglePick(picks, [id], "picked");
};

/**
 * What Fulfil does with the ticks. Every line picked, or none ticked nor
 * reported missing: Fulfilled. Otherwise Attention / Partially fulfilled,
 * the pop-up filled in from the ticks (`prefill`, by line id): lines ticked
 * saleable in full, lines reported missing not; lines not touched keep what
 * the order has.
 */
export const fulfilPlan = (picks, lines, statusName) => {
  const states = lines.map((item) => pickStateOf(picks, item, statusName));
  const done = states.filter((state) => state === "picked").length;
  const missing = states.filter((state) => state === "missing").length;
  const partial = done > 0 ? done < lines.length : missing > 0;
  const prefill = {};
  lines.forEach((item, index) => {
    const id = String(item?.id);
    if (picks.picked.has(id)) {
      prefill[id] = {
        is_saleable: true,
        saleable_item_quantity: item?.item_quantity,
      };
    } else if (states[index] === "missing") {
      prefill[id] = { is_saleable: false, saleable_item_quantity: "0" };
    }
  });
  return { done, missing, total: lines.length, partial, prefill };
};
